{
  "Your Stripe account, your branding, your price": "Tu cuenta de Stripe, tu marca, tu precio",
  "Our fee is just US $1.50 per ticket sold (introductory offer)": "Nuestra comisión es de solo US $1.50 por boleto vendido (oferta de lanzamiento)",
  "All countries and 31 currencies supported": "Compatible con todos los países y 31 monedas",
  "A fixed price, or let buyers choose the price": "Un precio fijo, o deja que los compradores elijan el precio",
  "Coupons and other Stripe features": "Cupones y otras funciones de Stripe",
  "Currency": "Moneda",
  "Loading currencies…": "Cargando monedas…",
  "Amount": "Monto",
  "Fee": "Comisión",
  "{code} - {name} (No auto-conversion)": "{code} - {name} (sin conversión automática)",
  "Search currency...": "Buscar moneda...",
  "Add currency": "Agregar moneda",
  "Single day {price} (24h access)": "Un día {price} (acceso por 24 h)",
  "All {days} days {price}": "Los {days} días {price}",
  "Livestream {price} (no replay)": "Transmisión en vivo {price} (sin grabación)",
  "Livestream {price}": "Transmisión en vivo {price}",
  "Livestream + Replay {price}": "Transmisión en vivo + grabación {price}",
  "+ video download add-on {price}": "+ descarga del video (opcional) {price}",
  "+ service & processing fee at checkout": "+ comisión de servicio y procesamiento al pagar",
  "Video download {price} (live-only event — no replay)": "Descarga del video {price} (evento solo en vivo, sin grabación)",
  "Nothing (live-only event with downloads off)": "Nada (evento solo en vivo con las descargas desactivadas)",
  "Replay {price}": "Grabación {price}",
  "Replay + download": "Grabación + descarga",
  "What buyers will see": "Lo que verán los compradores",
  "Before & during the event: {items}": "Antes y durante el evento: {items}",
  "After the event: {items}": "Después del evento: {items}",
  "Unlink Stripe Account": "Desvincular cuenta de Stripe",
  "Are you sure you want to unlink your Stripe account? This will disable ticket sales for this event.": "¿Quieres desvincular tu cuenta de Stripe? Se desactivará la venta de boletos para este evento.",
  "Failed to unlink Stripe account. Please try again.": "No se pudo desvincular la cuenta de Stripe. Inténtalo de nuevo.",
  "Sell tickets": "Vender boletos",
  "Couldn't load currencies": "No se pudieron cargar las monedas",
  "Check your connection and try again.": "Revisa tu conexión e inténtalo de nuevo.",
  "Guests pay to watch, and the money goes straight to your Stripe account.": "Los invitados pagan por ver y el dinero llega directamente a tu cuenta de Stripe.",
  "Tickets for rooms": "Boletos para las salas",
  "Connect Stripe account": "Conectar cuenta de Stripe",
  "Copy link to connect Stripe": "Copiar enlace para conectar Stripe",
  "Send it to the Stripe account's owner.": "Envíalo al titular de la cuenta de Stripe.",
  "Not your Stripe account? Send the link to its owner so they can connect it.": "¿No es tu cuenta de Stripe? Envía el enlace a su titular para que la conecte.",
  "Stripe fees, refunds and chargebacks are the connected account holder's responsibility. Need help setting up? Ask us in the support chat.": "Las comisiones de Stripe, los reembolsos y los contracargos son responsabilidad del titular de la cuenta conectada. ¿Necesitas ayuda para configurarla? Pregúntanos en el chat de soporte.",
  "Stripe account connected": "Cuenta de Stripe conectada",
  "Stripe dashboard": "Panel de Stripe",
  "Refresh": "Actualizar",
  "Unlink": "Desvincular",
  "How guests pay": "Cómo pagan los invitados",
  "Disable Pay-Per-View": "Desactivar el pago por evento",
  "Use Existing Stripe Price": "Usar un precio existente de Stripe",
  "Custom Price (Fixed)": "Precio personalizado (fijo)",
  "Customer Chooses Price": "El cliente elige el precio",
  "Choose how guests pay": "Elige cómo pagan los invitados",
  "Select Stripe Price": "Selecciona un precio de Stripe",
  "price|None": "Ninguno",
  "Custom Prices": "Precios personalizados",
  "This event is live-only, so the ticket includes the livestream only (no replay).": "Este evento es solo en vivo, así que el boleto incluye únicamente la transmisión en vivo (sin grabación).",
  "The ticket includes the livestream.": "El boleto incluye la transmisión en vivo.",
  "The ticket includes the livestream and the replay.": "El boleto incluye la transmisión en vivo y la grabación.",
  "Set prices for each currency. First currency becomes the default.": "Define un precio para cada moneda. La primera será la moneda predeterminada.",
  "Sell single-day tickets": "Vender boletos de un día",
  "Your price above is the All-Days ticket. Set one price per day below — buyers choose which day. Single-day access lasts 24 hours from that day's scheduled start time.": "El precio de arriba es el del boleto para todos los días. Define abajo el precio por día: los compradores eligen qué día. El acceso de un día dura 24 horas desde la hora de inicio programada de ese día.",
  "Sell video download": "Vender la descarga del video",
  "Buyers can add the downloadable video to any ticket for this amount.": "Los compradores pueden agregar el video descargable a cualquier boleto por este monto.",
  "After the event it's sold on its own since this event is live-only.": "Después del evento se vende por separado, ya que este evento es solo en vivo.",
  "After the event it's sold as Replay + Download.": "Después del evento se vende como “Grabación + descarga”.",
  "Single-day buyers can only download their day.": "Quienes compran un solo día pueden descargar únicamente ese día.",
  "+ Set a different replay price after the event (optional)": "+ Definir otro precio para la grabación después del evento (opcional)",
  "Replay price after the event": "Precio de la grabación después del evento",
  "Use ticket price": "Usar el precio del boleto",
  "Once the event is over, new buyers pay this instead of the ticket price. You can also change any price at any time.": "Cuando termine el evento, los nuevos compradores pagarán este precio en lugar del precio del boleto. También puedes cambiar cualquier precio cuando quieras.",
  "Add fees at checkout (buyers pay the fees)": "Agregar las comisiones al pagar (las pagan los compradores)",
  "Buyers pay one combined EventLive + card processing fee on top of your price, so you receive the full amount you set (card fees are estimated at the standard rate — unusual cards may vary slightly).": "Los compradores pagan, además de tu precio, una sola comisión que combina la de EventLive y la de procesamiento de tarjeta, así que recibes el monto completo que definiste (las comisiones de tarjeta se calculan con la tarifa estándar; con algunas tarjetas poco comunes pueden variar un poco).",
  "Fees are currently deducted from your price: the EventLive fee shown above plus Stripe's card processing fee.": "Actualmente, las comisiones se descuentan de tu precio: la comisión de EventLive que ves arriba más la comisión de Stripe por procesar la tarjeta.",
  "Default Price Suggestions": "Precios sugeridos",
  "These are suggested amounts customers will see, but they can enter any amount they wish.": "Son los montos sugeridos que verán los clientes, pero pueden ingresar el monto que quieran.",
  "More settings": "Más opciones",
  "Upload logo in Profile Settings": "Subir el logotipo en la configuración del perfil",
  "Invite free viewers in Guest List": "Invitar gratis a espectadores desde la lista de invitados",
  "Customize event branding": "Personalizar la marca del evento",
  "Enable payment emails in Stripe": "Activar los correos de pago en Stripe",
  "Customize branding in Stripe": "Personalizar la marca en Stripe",
  "Credits Added Successfully": "Créditos agregados correctamente",
  "Thank You for Your Purchase!": "¡Gracias por tu compra!",
  "Your credits are ready to use. You can now:": "Tus créditos están listos para usar. Ahora puedes:",
  "You can now:": "Ahora puedes:",
  "Use your credits to unlock more events": "Usar tus créditos para desbloquear más eventos",
  "Check your available balance before your next purchase": "Consultar tu saldo disponible antes de tu próxima compra",
  "Return to your events and keep editing": "Volver a tus eventos y seguir editando",
  "Invite guests to your event by sharing the event link or using the Guest List feature": "Invitar a quien quieras a tu evento compartiendo el enlace del evento o con la lista de invitados",
  "Open \"How to Go Live\" for a step-by-step guide": "Abrir “Cómo transmitir en vivo” para ver una guía paso a paso",
  "Go live on the day of your event": "Transmitir en vivo el día de tu evento",
  "Return to Event": "Volver al evento",
  "View My Events": "Ver mis eventos",
  "Afghanistan": "Afganistán",
  "Åland Islands": "Islas Åland",
  "Albania": "Albania",
  "Algeria": "Argelia",
  "American Samoa": "Samoa Americana",
  "Andorra": "Andorra",
  "Angola": "Angola",
  "Anguilla": "Anguila",
  "Antarctica": "Antártida",
  "Antigua and Barbuda": "Antigua y Barbuda",
  "Argentina": "Argentina",
  "Armenia": "Armenia",
  "Aruba": "Aruba",
  "Australia": "Australia",
  "Austria": "Austria",
  "Azerbaijan": "Azerbaiyán",
  "Bahamas": "Bahamas",
  "Bahrain": "Baréin",
  "Bangladesh": "Bangladesh",
  "Belgium": "Bélgica",
  "Belize": "Belice",
  "Benin": "Benín",
  "Bermuda": "Bermudas",
  "Bhutan": "Bután",
  "Bolivia": "Bolivia",
  "Bosnia and Herzegovina": "Bosnia y Herzegovina",
  "Botswana": "Botsuana",
  "Bouvet Island": "Isla Bouvet",
  "Brazil": "Brasil",
  "British Indian Ocean Territory": "Territorio Británico del Océano Índico",
  "Brunei Darussalam": "Brunéi",
  "Bulgaria": "Bulgaria",
  "Burkina Faso": "Burkina Faso",
  "Burundi": "Burundi",
  "Cambodia": "Camboya",
  "Cameroon": "Camerún",
  "Canada": "Canadá",
  "Cape Verde": "Cabo Verde",
  "Cayman Islands": "Islas Caimán",
  "Central African Republic": "República Centroafricana",
  "Chad": "Chad",
  "Chile": "Chile",
  "China": "China",
  "Christmas Island": "Isla de Navidad",
  "Cocos (Keeling) Islands": "Islas Cocos",
  "Colombia": "Colombia",
  "Comoros": "Comoras",
  "Congo": "Congo",
  "Congo, The Democratic Republic of the": "República Democrática del Congo",
  "Cook Islands": "Islas Cook",
  "Costa Rica": "Costa Rica",
  "Cote D Ivoire": "Costa de Marfil",
  "Croatia": "Croacia",
  "Cuba": "Cuba",
  "Cyprus": "Chipre",
  "Czech Republic": "República Checa",
  "Denmark": "Dinamarca",
  "Djibouti": "Yibuti",
  "Dominica": "Dominica",
  "Dominican Republic": "República Dominicana",
  "Ecuador": "Ecuador",
  "Egypt": "Egipto",
  "El Salvador": "El Salvador",
  "Equatorial Guinea": "Guinea Ecuatorial",
  "Eritrea": "Eritrea",
  "Estonia": "Estonia",
  "Ethiopia": "Etiopía",
  "Falkland Islands (Malvinas)": "Islas Malvinas",
  "Faroe Islands": "Islas Feroe",
  "Fiji": "Fiyi",
  "Finland": "Finlandia",
  "France": "Francia",
  "French Guiana": "Guayana Francesa",
  "French Polynesia": "Polinesia Francesa",
  "French Southern Territories": "Territorios Australes Franceses",
  "Gabon": "Gabón",
  "Gambia": "Gambia",
  "Georgia": "Georgia",
  "Germany": "Alemania",
  "Ghana": "Ghana",
  "Gibraltar": "Gibraltar",
  "Greece": "Grecia",
  "Greenland": "Groenlandia",
  "Grenada": "Granada",
  "Guadeloupe": "Guadalupe",
  "Guam": "Guam",
  "Guatemala": "Guatemala",
  "Guernsey": "Guernsey",
  "Guinea": "Guinea",
  "Guinea-Bissau": "Guinea-Bisáu",
  "Guyana": "Guyana",
  "Haiti": "Haití",
  "Heard Island and Mcdonald Islands": "Islas Heard y McDonald",
  "Holy See (Vatican City State)": "Ciudad del Vaticano",
  "Honduras": "Honduras",
  "Hong Kong": "Hong Kong",
  "Hungary": "Hungría",
  "Iceland": "Islandia",
  "India": "India",
  "Indonesia": "Indonesia",
  "Iran, Islamic Republic Of": "Irán",
  "Iraq": "Irak",
  "Ireland": "Irlanda",
  "Isle of Man": "Isla de Man",
  "Israel": "Israel",
  "Italy": "Italia",
  "Jamaica": "Jamaica",
  "Japan": "Japón",
  "Jersey": "Jersey",
  "Jordan": "Jordania",
  "Kazakhstan": "Kazajistán",
  "Kenya": "Kenia",
  "Kiribati": "Kiribati",
  "Korea, Democratic People Republic of": "Corea del Norte",
  "Korea, Republic of": "Corea del Sur",
  "Kuwait": "Kuwait",
  "Kyrgyzstan": "Kirguistán",
  "Lao People Democratic Republic": "Laos",
  "Latvia": "Letonia",
  "Lebanon": "Líbano",
  "Lesotho": "Lesoto",
  "Liberia": "Liberia",
  "Libyan Arab Jamahiriya": "Libia",
  "Liechtenstein": "Liechtenstein",
  "Lithuania": "Lituania",
  "Luxembourg": "Luxemburgo",
  "Macao": "Macao",
  "Macedonia, The Former Yugoslav Republic of": "Macedonia del Norte",
  "Madagascar": "Madagascar",
  "Malawi": "Malaui",
  "Malaysia": "Malasia",
  "Maldives": "Maldivas",
  "Mali": "Malí",
  "Malta": "Malta",
  "Marshall Islands": "Islas Marshall",
  "Martinique": "Martinica",
  "Mauritania": "Mauritania",
  "Mauritius": "Mauricio",
  "Mayotte": "Mayotte",
  "Mexico": "México",
  "Micronesia, Federated States of": "Micronesia",
  "Moldova, Republic of": "Moldavia",
  "Monaco": "Mónaco",
  "Mongolia": "Mongolia",
  "Montserrat": "Montserrat",
  "Morocco": "Marruecos",
  "Mozambique": "Mozambique",
  "Myanmar": "Myanmar",
  "Namibia": "Namibia",
  "Nauru": "Nauru",
  "Nepal": "Nepal",
  "Netherlands": "Países Bajos",
  "Netherlands Antilles": "Antillas Neerlandesas",
  "New Caledonia": "Nueva Caledonia",
  "New Zealand": "Nueva Zelanda",
  "Nicaragua": "Nicaragua",
  "Niger": "Níger",
  "Nigeria": "Nigeria",
  "Niue": "Niue",
  "Norfolk Island": "Isla Norfolk",
  "Northern Mariana Islands": "Islas Marianas del Norte",
  "Norway": "Noruega",
  "Oman": "Omán",
  "Pakistan": "Pakistán",
  "Palau": "Palaos",
  "Palestinian Territory, Occupied": "Territorios Palestinos",
  "Panama": "Panamá",
  "Papua New Guinea": "Papúa Nueva Guinea",
  "Paraguay": "Paraguay",
  "Peru": "Perú",
  "Philippines": "Filipinas",
  "Pitcairn": "Islas Pitcairn",
  "Poland": "Polonia",
  "Portugal": "Portugal",
  "Puerto Rico": "Puerto Rico",
  "Qatar": "Qatar",
  "Reunion": "Reunión",
  "Romania": "Rumania",
  "Russian Federation": "Rusia",
  "RWANDA": "Ruanda",
  "Saint Helena": "Santa Elena",
  "Saint Kitts and Nevis": "San Cristóbal y Nieves",
  "Saint Lucia": "Santa Lucía",
  "Saint Pierre and Miquelon": "San Pedro y Miquelón",
  "Saint Vincent and the Grenadines": "San Vicente y las Granadinas",
  "Samoa": "Samoa",
  "San Marino": "San Marino",
  "Sao Tome and Principe": "Santo Tomé y Príncipe",
  "Saudi Arabia": "Arabia Saudita",
  "Senegal": "Senegal",
  "Serbia and Montenegro": "Serbia y Montenegro",
  "Seychelles": "Seychelles",
  "Sierra Leone": "Sierra Leona",
  "Singapore": "Singapur",
  "Slovakia": "Eslovaquia",
  "Slovenia": "Eslovenia",
  "Solomon Islands": "Islas Salomón",
  "Somalia": "Somalia",
  "South Africa": "Sudáfrica",
  "South Georgia and the South Sandwich Islands": "Islas Georgia del Sur y Sandwich del Sur",
  "Spain": "España",
  "Sri Lanka": "Sri Lanka",
  "Sudan": "Sudán",
  "Suriname": "Surinam",
  "Svalbard and Jan Mayen": "Svalbard y Jan Mayen",
  "Swaziland": "Suazilandia",
  "Sweden": "Suecia",
  "Switzerland": "Suiza",
  "Syrian Arab Republic": "Siria",
  "Taiwan, Province of China": "Taiwán",
  "Tajikistan": "Tayikistán",
  "Tanzania, United Republic of": "Tanzania",
  "Thailand": "Tailandia",
  "Timor-Leste": "Timor Oriental",
  "Togo": "Togo",
  "Tokelau": "Tokelau",
  "Tonga": "Tonga",
  "Trinidad and Tobago": "Trinidad y Tobago",
  "Tunisia": "Túnez",
  "Turkey": "Turquía",
  "Turkmenistan": "Turkmenistán",
  "Turks and Caicos Islands": "Islas Turcas y Caicos",
  "Tuvalu": "Tuvalu",
  "Uganda": "Uganda",
  "Ukraine": "Ucrania",
  "United Arab Emirates": "Emiratos Árabes Unidos",
  "United Kingdom": "Reino Unido",
  "United States": "Estados Unidos",
  "United States Minor Outlying Islands": "Islas menores alejadas de EE. UU.",
  "Uruguay": "Uruguay",
  "Uzbekistan": "Uzbekistán",
  "Vanuatu": "Vanuatu",
  "Venezuela": "Venezuela",
  "Viet Nam": "Vietnam",
  "Virgin Islands, British": "Islas Vírgenes Británicas",
  "Virgin Islands, U.S.": "Islas Vírgenes de EE. UU.",
  "Wallis and Futuna": "Wallis y Futuna",
  "Western Sahara": "Sáhara Occidental",
  "Yemen": "Yemen",
  "Zambia": "Zambia",
  "Zimbabwe": "Zimbabue",
  "Your client's account · used for {count} event": {
    "one": "Cuenta de tu cliente · se usa en {count} evento",
    "other": "Cuenta de tu cliente · se usa en {count} eventos"
  },
  "Your client's account": "Cuenta de tu cliente",
  "Your account · used for {count} event": {
    "one": "Tu cuenta · se usa en {count} evento",
    "other": "Tu cuenta · se usa en {count} eventos"
  },
  "Your account": "Tu cuenta",
  "Used for {count} event": {
    "one": "Se usa en {count} evento",
    "other": "Se usa en {count} eventos"
  },
  "Connected before": "Conectada antes",
  "Ticket payouts for “{event}” will go to {account}, your client's Stripe account. Use it only for this client's events.": "Los cobros de boletos de “{event}” irán a {account}, la cuenta de Stripe de tu cliente. Úsala solo para los eventos de este cliente.",
  "Ticket payouts for “{event}” will go to {account}.": "Los cobros de boletos de “{event}” irán a {account}.",
  "Use this account": "Usar esta cuenta",
  "Couldn't use this Stripe account": "No se pudo usar esta cuenta de Stripe",
  "Use a Stripe account you've connected before": "Usa una cuenta de Stripe que ya conectaste",
  "Or connect another Stripe account:": "O conecta otra cuenta de Stripe:",
  "Connect another Stripe account": "Conectar otra cuenta de Stripe"
}
